<template>
    <div>
        <div v-if="loading">
            <LiveLogoLoading />
        </div>
        <div class="w-100 float-right bg-light" v-else>
            <Navbar />
            <ShopCategory v-if="shopCategory"
                          :shopCategory="shopCategory"
                          :rootImagePath="rootImagePath" />
            <ShopCategories v-if="shopCategories.length > 0"
                            :shopCategories="shopCategories"
                            :provinceName="provinceName"
                            :provinceId="provinceId"
                            :rootImagePath="rootImagePath" />
            <Provinces v-if="provinces.length > 0"
                       :provinces="provinces"
                       :rootImagePath="rootImagePath" />
            <Footer />
        </div>
    </div>
</template>
<script>
    import LiveLogoLoading from "@/components/LiveLogoLoading";
    import ShopCategories from "./shops/ShopCategories";
    import ShopCategory from "./shops/ShopCategory";
    import Provinces from "./shops/Provinces";
    import Navbar from "./share/Navbar";
    import Footer from "./share/Footer";

    import utility from "@/plugins/utility";
    const db = new utility.db();

    export default {
        components: {
            LiveLogoLoading,
            ShopCategories,
            ShopCategory,
            Provinces,
            Navbar,
            Footer
        },

        data()
        {
            return {
                loading: true,
                rootImagePath: "",
                provinceId: null,
                shopCategoryId: null,
                provinceName: "",
                provinces: [],
                shopCategories: [],
                shopCategory: null
            };
        },

        beforeMount()
        {
            this.provinceId = this.$route.params.provinceId;
            this.shopCategoryId = this.$route.params.shopCategoryId;

            if (this.$route.params.name)
            {
                this.provinceName =
                    this.$route.params.name.replace(/-/gi, ' ');
            }

            this.initShops();
        },

        methods: {
            initShops()
            {
                if (this.provinceId != null && this.shopCategoryId != null && this.shopCategoryId != "0")
                {

                    const insertName =
                        "shopCategory_" + this.provinceId + "_" + this.shopCategoryId

                    if (db.select(insertName)) this.initData(db.select(insertName), insertName);

                    axios({
                        method: "post",
                        url: "/api/General/GetShops",
                        data: { ProvinceID: this.provinceId, ShopCategoryID: this.shopCategoryId }
                    })
                        .then(response =>
                        {
                            this.initData(response.data, insertName)
                        })
                        .catch(error => { });

                }
                else
                    if (this.provinceId != null)
                    {
                        const insertName =
                            "shops_" + this.provinceId

                        if (db.select(insertName)) this.initData(db.select(insertName), insertName);

                        axios({
                            method: "post",
                            url: "/api/General/GetShopCategoriesWithShops",
                            data: { ProvinceID: this.provinceId }
                        })
                            .then(response =>
                            {
                                this.initData(response.data, insertName)
                            })
                            .catch(error => { });

                    } else
                    {
                        const insertName = "provincesActiveShop"
                        if (db.select(insertName)) this.initData(db.select(insertName), insertName);

                        axios({ method: "get", url: "/api/General/GetProvincesActiveShop" })
                            .then(response =>
                            {
                                this.initData(response.data, insertName)
                            })
                            .catch(error => { });
                    }
            },

            initData(obj, insertName)
            {

                this.rootImagePath = obj.rootImagePath;

                if (obj.shopCategories)
                    this.shopCategories = obj.shopCategories;

                if (obj.provinces)
                    this.provinces = obj.provinces;

                if (obj.shopCategory)
                    this.shopCategory = obj.shopCategory;


                db.insert(insertName, obj);
                this.loading = false;
            }
        }
    };
</script>
